import { getAgeInputQuizTemplate, getVueAgeInputQuizTemplate } from "../../shortcodes/templates";

let ageInput = null;
const visualizeAgeInputQuiz = content => {
  ageInput = content.querySelectorAll('[data-wrapper-id="age-input-quiz"]');
  if (ageInput.length > 0) {
    ageInput.forEach(item => {
      item.innerHTML = getAgeInputQuizTemplate();
    });
  }
};

const serializeAgeInputQuiz = content => {
  const ageInputWidget = content.querySelectorAll('[data-wrapper-id="age-input-quiz"]');
  if (ageInputWidget.length > 0) {
    ageInputWidget.forEach(item => {
      const quizData = item.getAttribute("data-age-input-data");
      item.innerHTML = getVueAgeInputQuizTemplate(quizData);
    });
  }
};

export { visualizeAgeInputQuiz, serializeAgeInputQuiz };
